import {
  Step,
  StepButton,
  StepLabel,
  Stepper,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { ColorlibConnector, CustomStepIcon } from "./custom-stepIcon";

interface MuiStepperProps {
  steps: string[];
  activeStep: number;
  handleStep: (step: number) => void;
  width?: string;
}

const MuiStepper: React.FC<MuiStepperProps> = ({
  steps,
  activeStep,
  handleStep,
  width = "75%",
}) => {
  const isMobile = useMediaQuery("(max-width:500px)");

  return (
    <Stepper
      nonLinear
      activeStep={activeStep}
      sx={{ width: width }}
      connector={<ColorlibConnector />}
      orientation={isMobile ? "vertical" : "horizontal"}
    >
      {steps.map((label: string, index: number) => (
        <Step key={label} completed={index < activeStep}>
          <StepButton color="inherit" onClick={() => handleStep(index)}>
            <StepLabel StepIconComponent={CustomStepIcon}>{label}</StepLabel>
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
};

export default MuiStepper;
